export default {
  title: 'New employee',
  buttonCancel: 'Cancel',
  buttonAdd: 'Add Employee',
};
